import styled from 'styled-components';

export const SessionCounter = styled.div`
  display: block;
  margin-top: 1rem;
  margin-bottom: 2rem;
  font-size: 1.5rem;
  font-weight: bold;
  text-align: center;
`;
